export default __webpack_public_path__ + "static/media/AtticusAnimation_v2.46b079fd.gif";